/** **************************** Import Types ****************************** */
import {
  UPDATE_TIMELINE_REQUEST,
  UPDATE_TIMELINE_SUCCESS,
  UPDATE_TIMELINE_FAILURE,
} from "../types/updateTimeline.types";

const initialState = {
  loading: false,
  storeLoginResponse: "",
  error: "",
};

const TimeLineReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TIMELINE_REQUEST:
      return {
        ...state,
        loading: true,
        storeLoginResponse: "",
      };
    case UPDATE_TIMELINE_SUCCESS:
      return {
        loading: false,
        storeLoginResponse: action.payload.responseStatus,
        error: "",
      };
    case UPDATE_TIMELINE_FAILURE:
      return {
        loading: false,
        storeLoginResponse: "error",
        error: action.payload,
      };
    default:
      return state;
  }
};

export default TimeLineReducer;
